import { httpClient } from '../http-client'
import type {
  UserProfileResponse,
  UpdateProfileData,
  SessionStatsResponse,
  FirstAccessData,
  FirstAccessResponse
} from '@/types/api'

/**
 * ProfileService - Gerencia perfil e estatísticas do usuário
 */
class ProfileService {
  async getProfile(
    idOrEmail: string,
    type: 'complete' | 'simple' = 'complete'
  ): Promise<UserProfileResponse> {
    if (!idOrEmail || idOrEmail?.length === 0) {
      throw new Error('Id or email is required')
    }
    const response = await httpClient.get(`/profiles/${idOrEmail}`, {
      params: { type }
    })
    return response.data
  }

  async updateProfile(id: string, data: UpdateProfileData) {
    const response = await httpClient.patch(`/profiles/${id}`, data)
    return response.data
  }

  // Estatísticas de sessão do usuário
  async getSessionStats(profileId: string, params?: { page?: number; limit?: number }): Promise<SessionStatsResponse> {
    const response = await httpClient.get(`/profiles/${profileId}/sessions/stats`, { params })
    return response.data
  }

  // Histórico de sessões do usuário
  async getSessionHistory(profileId: string, params?: { page?: number; limit?: number }) {
    const response = await httpClient.get(`/profiles/${profileId}/sessions/history`, { params })
    return response.data
  }

  // Atualização de primeira senha/alteração de senha
  async updateFirstAccess(data: FirstAccessData): Promise<FirstAccessResponse> {
    const response = await httpClient.patch('/profiles/first-access-update', data)
    return response.data
  }
}

export const profileService = new ProfileService()
